import styled from '@emotion/styled';
import { Placement } from '@popperjs/core';
import { TooltipPopperPropTypes } from './Tooltip.types';

export const TooltipButton = styled.button`
  width: fit-content;
  height: fit-content;
  outline: none;
  &:focus {
    outline: none;
  }
`;

function getBoxShadow({ placement }) {
  if (placement?.includes('start')) {
    return '-1px 4px 8px #0005';
  }
  if (placement?.includes('end')) {
    return '1px 4px 8px #0005';
  }
  return null;
}

function getAlignment({ placement }) {
  if (placement?.includes('start')) {
    return 'flex-end';
  }
  if (placement?.includes('start')) {
    return 'flex-start';
  }
  return null;
}

export const TooltipPopper = styled.div<TooltipPopperPropTypes>`
  position: relative;
  height: ${({ $height }) => $height}px;
  width: ${({ $width }) => $width}px;
  font-size: 1.125rem;
  padding: 0.625rem 1rem;
  background-color: #fff;
  box-shadow: ${getBoxShadow};
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: ${({ placement }) =>
    placement?.includes('start') ? 0.5 : 0}rem;
  border-bottom-left-radius: ${({ placement }) =>
    placement?.includes('end') ? 0.5 : 0}rem;
`;

export const Arrow = styled.span<{ placement: Placement }>`
  display: block;
  height: 10px;
  width: 10px;
  background-color: inherit;
  position: absolute;
  bottom: -5px;
  left: ${({ placement }) => (placement?.includes('start') ? '2px' : 'unset')};
  right: ${({ placement }) => (placement?.includes('end') ? '2px' : 'unset')};
  clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
  transform: rotate(-45deg);
  border-radius: 0 0 0 0.125rem;
`;

export const PopperWrapper = styled.div<TooltipPopperPropTypes>`
  height: ${({ $height }) => $height + 10}px;
  width: ${({ $width }) => $width + 10}px;

  display: flex;
  align-items: flex-start;
  justify-content: ${getAlignment};
`;
